import { render, staticRenderFns } from "./input-brief.vue?vue&type=template&id=86eae64e&"
import script from "./input-brief.vue?vue&type=script&lang=js&"
export * from "./input-brief.vue?vue&type=script&lang=js&"
import style0 from "./input-brief.vue?vue&type=style&index=0&id=86eae64e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports